<div class="product-feature-grid" [class]="'product-feature-grid ' + gridClass" role="list">
  <ng-container *ngFor="let slot of slots; trackBy: trackBySortOrder">
    <ng-container *ngIf="cellItem(slot.sortOrder) as item">
      <a
        *ngIf="cellLink(item) as link; else interactivePf"
        class="product-feature-grid__cell"
        [class]="'product-feature-grid__cell product-feature-grid__cell--' + slot.area"
        [routerLink]="link"
        role="listitem"
      >
        <ng-container *ngTemplateOutlet="pfInner; context: { $implicit: item, slot: slot }"></ng-container>
      </a>
      <ng-template #interactivePf>
        <div
          class="product-feature-grid__cell"
          [class]="'product-feature-grid__cell product-feature-grid__cell--' + slot.area"
          [class.product-feature-grid__cell--zoom]="zoomOnClick && item.mediaUrl"
          [attr.role]="zoomOnClick ? 'button' : 'listitem'"
          [attr.tabindex]="zoomOnClick && item.mediaUrl ? 0 : null"
          [attr.aria-label]="zoomOnClick ? (item.title || 'Open image') : null"
          (click)="onCellActivate(item)"
          (keydown)="onCellKeydown($event, item)"
        >
          <ng-container *ngTemplateOutlet="pfInner; context: { $implicit: item, slot: slot }"></ng-container>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</div>

<ng-template #pfInner let-item let-slot="slot">
  <img
    *ngIf="item.mediaType !== 'video'"
    class="product-feature-grid__media"
    [appMediaSrc]="item.mediaUrl"
    [appMediaProfile]="mediaProfileForSlot(slot)"
    [appMediaSlotHint]="slot.hintPx"
    [appMediaSizes]="sizesForSlot(slot)"
    [appMediaSharp]="true"
    [appMediaProgressive]="false"
    appMediaPlaceholder="/assets/placeholder.svg"
    [width]="bannerNative.width"
    [height]="bannerNative.height"
    [alt]="item.title || ''"
    loading="lazy"
    decoding="async"
  />
  <video
    *ngIf="item.mediaType === 'video'"
    class="product-feature-grid__media"
    [appMediaSrc]="item.mediaUrl"
    muted
    loop
    playsinline
    autoplay
  ></video>
  <div class="product-feature-grid__overlay" *ngIf="item.badgeText || item.title || item.description">
    <span class="product-feature-grid__badge" *ngIf="item.badgeText">{{ item.badgeText }}</span>
    <h3 class="product-feature-grid__title" *ngIf="item.title">{{ item.title }}</h3>
    <p class="product-feature-grid__desc" *ngIf="item.description">{{ item.description }}</p>
  </div>
</ng-template>
